export const DASHBOARD_VIEW_ANALYZE_QUESTION = 'What am I seeing on the screen right now?';

/** Backend tool name — LLM calls this; frontend captures the screenshot. */
export const CAPTURE_DASHBOARD_SCREENSHOT_TOOL = 'capture_dashboard_screenshot';

const DASHBOARD_CAPTURE_IGNORE_SELECTORS = [
  '[data-digisaka-gpt-ui]',
  '[data-digisaka-welcome-modal]',
  '[data-digisaka-guest-overlay]',
].join(',');

export function buildDashboardScreenshotToolResult(
  imageDataUrl: string,
  focus?: string | null
): Array<{ type: string; text?: string; image_url?: { url: string } }> {
  const focusNote = focus?.trim() ? ` Focus: ${focus.trim()}.` : '';
  return [
    {
      type: 'text',
      text:
        'Dashboard screenshot captured successfully. The Pandoy AI chat window was excluded.' +
        focusNote +
        ' Describe visible map layers, panels, charts, and field context, then answer the user.',
    },
    { type: 'image_url', image_url: { url: imageDataUrl } },
  ];
}

function shouldIgnoreDashboardCaptureElement(element: Element): boolean {
  return element.matches(DASHBOARD_CAPTURE_IGNORE_SELECTORS) ||
    element.closest(DASHBOARD_CAPTURE_IGNORE_SELECTORS) !== null;
}

export async function captureDashboardScreenshot(root: HTMLElement): Promise<string | null> {
  const html2canvasModule = await import('html2canvas');
  const canvas = await html2canvasModule.default(root, {
    useCORS: true,
    logging: false,
    scale: Math.min(window.devicePixelRatio || 1, 1.25),
    ignoreElements: (element) => shouldIgnoreDashboardCaptureElement(element),
  });
  return canvas.toDataURL('image/png');
}
